"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/* tslint:disable */

/* eslint-disable */
var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GeneToolTip_gene",
  "selections": [{
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }, {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "href",
    "storageKey": null
  }, {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "slug",
    "storageKey": null
  }, {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "internalID",
    "storageKey": null
  }, {
    "alias": null,
    "args": null,
    "concreteType": "Image",
    "kind": "LinkedField",
    "name": "image",
    "plural": false,
    "selections": [{
      "alias": null,
      "args": [{
        "kind": "Literal",
        "name": "version",
        "value": "tall"
      }],
      "kind": "ScalarField",
      "name": "url",
      "storageKey": "url(version:\"tall\")"
    }],
    "storageKey": null
  }, {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }],
  "type": "Gene"
};
node.hash = 'ab5f28661f9c5437186bbdaa00ac1414';
var _default = node;
exports.default = _default;
//# sourceMappingURL=GeneToolTip_gene.graphql.js.map